<i class="fal fa-globe"
  [ngClass]="cssClass() === 'header' ? 'header-icon' : 'footer-icon'">
</i>
<select
  id="languageSelect"
  placement="bottom"
  triggers="manual"
  [ngClass]="cssClass() === 'header' ? 'header-section' : 'footer-section'"
  [(ngModel)]="languageSelected"
  (change)="selectLanguage()">
  @for (language of (brandingSettings$ | async); track language) {
    <option
      class="options-color"
      [ngValue]="language"
      >
      {{ language }}
    </option>
  }
</select>
